// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__ok3Ho","col":"Table_col__1C3GI","fulfillmentStatus":"Table_fulfillmentStatus__1ZjY6","emailCol":"Table_emailCol__9eo6X"};